import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { AdminService } from '../../../../../services/administrator/admin.service';
import { MaterialModule } from '../../../../../shared/module/material.module';
import { SharedServices } from '../../../../../shared/services/shared.services';
@Component({
  selector: 'app-add-update-dialog',
  imports: [CommonModule,MaterialModule,ReactiveFormsModule],
  templateUrl: './add-update-dialog.component.html',
  styleUrl: './add-update-dialog.component.css'
})
export class AddUpdateDialogComponent {
  DoaCategoryForm: FormGroup;
  isDeveloper: boolean = false;
  isLoading: boolean = false;
  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddUpdateDialogComponent>,
    private http: HttpClient,
    private adminService: AdminService,
    private sharedService:SharedServices
  ) {
    this.DoaCategoryForm = this.fb.group({
      id: [data.user?.id || null],
      catCode: [{value : data.user?.catCode || '', disabled: data.isEdit},[Validators.required, Validators.maxLength(1)]],
      catName: [data.user?.catName || '', [Validators.required, Validators.maxLength(100)]],
      catTitle: [data.user?.catTitle || '',[Validators.maxLength(1000)]],
      delegated: [data.user?.delegated || '', Validators.required]
    });
  }

  ngOnInit(): void {
    if (this.data.isEdit) {
      this.DoaCategoryForm.patchValue(this.data.user);
      this.data.initialValues = this.DoaCategoryForm.getRawValue();
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    this.isLoading = true;
    if (this.DoaCategoryForm.invalid) {
      this.sharedService.openModal('Message', 'Please enter all required information');
      this.isLoading = false;
      return;
    }
  
    const catCode = this.DoaCategoryForm.get('catCode')?.value;
    const categoryExists = this.data.existingCategories.some((cat: any) => cat.catCode === catCode);
  
    if (!this.data.isEdit && categoryExists) {
      this.sharedService.openModal('Message', 'Category code already exists');
      this.isLoading = false;
    } else {
      if (this.data.isEdit) {
        const updatedCategory = this.DoaCategoryForm.getRawValue();
        if (JSON.stringify(this.data.initialValues) === JSON.stringify(updatedCategory)) {
          this.sharedService.openModal('Message', 'No changes detected');
          this.isLoading = false;
          return;
        }
        this.adminService.updateDoaCategory(updatedCategory).subscribe({
          next: response => {
            this.dialogRef.close(response);
            this.isLoading = false;
            this.sharedService.openModal('Message', 'Updated Successfully');
          },
          error: error => {
            console.error('Error updating category', error);
            this.isLoading = false;
          }
        });
      } else {
        this.adminService.addDoaCategory(this.DoaCategoryForm.value).subscribe({
          next: response => {
            this.dialogRef.close(true);
            this.isLoading = false;
            this.sharedService.openModal('Message', 'Added Successfully');
          },
          error: error => {
            console.error('Error adding category', error);
            this.isLoading = false;
          }
        });
      }
    }
  }
}
